(function () {
  function updateSpecsPanel(blockId, variantId) {
    var dataEl = document.getElementById('VariantSpecs-' + blockId);
    if (!dataEl) return;

    var specsData;
    try {
      specsData = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variantData = specsData[variantId] || {};
    renderTable('SpecsTable-' + blockId, variantData.specifications || []);
    renderTable('MeasurementsTable-' + blockId, variantData.measurements || []);
  }

  function renderTable(tableId, items) {
    var tbody = document.querySelector('#' + tableId + ' tbody');
    if (!tbody) return;

    if (!items || items.length === 0) {
      tbody.innerHTML = '<tr><td colspan="2" class="product-specs-empty">—</td></tr>';
      return;
    }

    tbody.innerHTML = items
      .map(function (item) {
        return (
          '<tr>' +
          '<td class="product-specs-label">' + escapeHtml(String(item.label || '')) + '</td>' +
          '<td class="product-specs-value">' + escapeHtml(String(item.value || '')) + '</td>' +
          '</tr>'
        );
      })
      .join('');
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  webvista.subscribe('variant-change', function (event) {
    var variant = event.data && event.data.variant;
    if (!variant) return;

    document.querySelectorAll('[data-specs-panel]').forEach(function (grid) {
      updateSpecsPanel(grid.dataset.specsPanel, String(variant.id));
    });
  });
})();
